import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface PageHeaderProps {
  onCreate: () => void;
  isLoading: boolean;
  title?: string;
  subtitle?: string;
}

export function PageHeader({
  onCreate,
  isLoading,
  title = 'Encomendas',
  subtitle = 'Visualize e gerencie as encomendas',
}: PageHeaderProps) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={3}
    >
      <Box>
        <Typography variant="h4">{title}</Typography>
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onCreate}
        disabled={isLoading}
      >
        Nova Encomenda
      </Button>
    </Box>
  );
}